<template>
    <div class="content-height-full">
        <prospect-map
            class="content-height-full"
            :prospects="[prospect]"
            :can-edit="false"
            :can-draw="true"
            @rendered="enableEditingForCommunity"
        />

        <div class="absolute items-center pin-x pin-b p-lg bg-white shadow flex flex-wrap-reverse justify-between rounded w-2/3 md:w-auto">
            <a :href="route('admin.prospects.community.create', communityToEdit.prospect.id)" class="btn btn-md is-ghost mr-md">
                Avbryt
            </a>
            <button
                class="btn btn-md is-primary mb-md md:mb-0"
                :disabled="busy"
                @click="save"
            >
                Spara
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            prospect: {
                type: Object,
                required: true,
            },
            center: {
                required: false,
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            communityToEdit: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                busy: false,
                coordinates: [],
                communities: [],
            };
        },
        created() {
            this.communities = this.prospect.communities;

            EventBus.$on('shape-edited', (polygon, shape) => {
                this.coordinates = polygon;
            });
        },
        methods: {
            enableEditingForCommunity() {
                window.EventBus.$emit('edit-shape', 'c' + this.communityToEdit.id);
            },
            async save() {
                try {
                    this.busy = true;

                    if (this.coordinates.length > 0) {
                        await axios.patch(
                            route('api.prospects.community.area.update', this.communityToEdit.id),
                            { polygon: this.coordinates },
                        );
                    }

                    window.location = route('admin.prospects.community.create', this.communityToEdit.prospect.id);
                    return;
                } catch (error) {
                    flash_error('Det gick inte att spara samfälligheten.');
                }

                this.busy = false;
            },
        },
    };
</script>